import { getTopic } from "@/api/topics";
import { AdminPageContent, AdminPageHeader } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { Stack } from "@mui/material";
import { useMountEffect } from "@react-hookz/web";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { TopicInfoSection } from "./components/topic-details/TopicInfoSection";
import { TopicSectionsPanel } from "./components/topic-details/TopicSectionsPanel";

/**
 * The details page for an admin topic.
 */
const AdminTopicDetails = () => {
    const { topicId } = useParams();
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Topic");

    const { data: topic } = useSuspenseQuery({
        queryKey: ["admin-topic-details", topicId],
        queryFn: () => getTopic(Number(topicId)),
    });

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Topics", path: "topics" },
            { label: topic.name },
        ]);
    });

    return (
        <AdminPageContent>
            <AdminPageHeader
                title={topic.name}
                subtitle="Topic configuration and associated sections"
            />
            <Stack spacing={3} pb={2} className="mt-6">
                <TopicInfoSection topic={topic} />
                <TopicSectionsPanel topic={topic} />
            </Stack>
        </AdminPageContent>
    );
};

export default AdminTopicDetails;
